import type { RouteObject } from "react-router";
import { MARKETING_ROUTES } from "../constants/marketing-routes";

export const marketingRouter: RouteObject = {
	children: [
		{
			path: MARKETING_ROUTES.HOME,
			lazy: async () => {
				const { default: HomePage } = await import("../pages/home-page");
				return { Component: HomePage };
			},
		},
		{
			path: MARKETING_ROUTES.FEATURES,
			lazy: async () => {
				const { default: FeaturesPage } = await import("../pages/features-page");
				return { Component: FeaturesPage };
			},
		},
		{
			path: MARKETING_ROUTES.FAQ,
			lazy: async () => {
				const { default: FaqPage } = await import("../pages/faq-page");
				return { Component: FaqPage };
			},
		},
		{
			path: MARKETING_ROUTES.DOWNLOAD,
			lazy: async () => {
				const { default: DownloadPage } = await import("../pages/download-page");
				return { Component: DownloadPage };
			},
		},
		{
			path: MARKETING_ROUTES.ABOUT,
			lazy: async () => {
				const { default: AboutPage } = await import("../pages/about-page");
				return { Component: AboutPage };
			},
		},
		{
			path: MARKETING_ROUTES.CONTACT,
			lazy: async () => {
				const { default: ContactPage } = await import("../pages/contact-page");
				return { Component: ContactPage };
			},
		},
		{
			path: MARKETING_ROUTES.LEGAL_NOTICE,
			lazy: async () => {
				const { default: LegalNoticePage } = await import("../pages/legal-notice-page");
				return { Component: LegalNoticePage };
			},
		},
		{
			path: MARKETING_ROUTES.PRIVACY,
			lazy: async () => {
				const { default: PrivacyPage } = await import("../pages/privacy-page");
				return { Component: PrivacyPage };
			},
		},
		{
			path: MARKETING_ROUTES.TERMS,
			lazy: async () => {
				const { default: TermsPage } = await import("../pages/terms-page");
				return { Component: TermsPage };
			},
		},
	],
};
